import { AccessType } from '@/enums/AccessType';
import { RAW_ROUTES } from '@/enums/RoutesMap';

export const createMeetingLink = (meetingId: string, accessType: AccessType) => {
  let uri = RAW_ROUTES.SharedMeeting;
  if (accessType === AccessType.PUBLIC) {
    uri = RAW_ROUTES.SharedPublicMeeting;
  }
  if (accessType === AccessType.ONLY_ME) {
    uri = RAW_ROUTES.Meeting;
  }
  return `${window.location.origin}${uri}${meetingId}`;
};
